import { VStack, Button, HStack, Sticky } from '@starrez/starryui9';
import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

export interface IModuleLayout {
    caption: React.ReactNode;
    subCaption?: React.ReactNode;
    newButtonCaption?: string;
    onNewButtonClick?: () => void;
    children: (props: DOMRect) => React.ReactNode;
    buttonBar?: React.ReactNode;
    filterControls?: React.ReactNode;
}

export const ModuleLayout: React.FC<IModuleLayout> = ({
    onNewButtonClick,
    children,
    caption,
    newButtonCaption,
    subCaption,
    buttonBar,
    filterControls,
}) => {
    const headerRef = React.createRef<HTMLDivElement>();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [size, setSize] = useState<any>(false);

    useLayoutEffect(() => {
        const header = headerRef.current;
        if (header) {
            setSize(header.getBoundingClientRect());
        }
    }, []);

    return (
        <ModuleWrapper>
            <Sticky maxWidth="calc(100vw - 95px)" background="white" zIndex={3} top="0px" left="0px">
                <StyledWrapper ref={headerRef}>
                    <VStack align="start" rows="auto auto" gap="xSmall">
                        <HStack columns="1fr auto">
                            <div>{caption}</div>

                            <div>
                                {newButtonCaption && (
                                    <Button icon={'Plus'} onClick={onNewButtonClick}>
                                        {newButtonCaption}
                                    </Button>
                                )}
                            </div>
                        </HStack>

                        <HStack columns="1fr auto">
                            <div style={{ paddingLeft: '8px' }}>{subCaption}</div>
                            {buttonBar && buttonBar}
                        </HStack>

                        {filterControls && <div style={{ minHeight: '40px' }}>{filterControls}</div>}
                    </VStack>
                </StyledWrapper>
            </Sticky>

            {size && children(size)}
        </ModuleWrapper>
    );
};

const StyledWrapper = styled.div`
    padding: 16px 8px 8px 16px;
`;

const ModuleWrapper = styled.div`
    min-width: calc(100vw - 80px);
    width: max-content;
    min-height: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
`;
